import request from '@/utils/request'

export function getCustomerPage(params) {
  return request({
    url: '/api/customer/page',
    method: 'get',
    params
  })
}

export function getCustomer(id) {
  return request({
    url: `/api/customer/${id}`,
    method: 'get'
  })
}

export function createCustomer(data) {
  return request({
    url: '/api/customer',
    method: 'post',
    data
  })
}

export function updateCustomer(id, data) {
  return request({
    url: `/api/customer/${id}`,
    method: 'put',
    data
  })
}
